import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ThemeSettings } from './theme/Theme';
import RTL from './layouts/full/shared/customizer/RTL';
import ScrollToTop from './components/shared/ScrollToTop';
import { CssBaseline, ThemeProvider } from '@mui/material';
import NotificationAlert from './components/shared/NotificationAlert';
import { AuthProvider } from './guards/jwt/JwtContext';
import { AlertProvider } from './context/AlertContext';

/**
 * Router layout: tema, auth ve sayfa içeriği (Outlet).
 */
function AppShell() {
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);

  return (
    <AuthProvider>
      <AlertProvider>
        <ThemeProvider theme={theme}>
          <RTL direction={customizer.activeDir}>
            <CssBaseline />
            <NotificationAlert />
            <ScrollToTop>
              <Outlet />
            </ScrollToTop>
          </RTL>
        </ThemeProvider>
      </AlertProvider>
    </AuthProvider>
  );
}

export default AppShell;
